module.exports = __webpack_public_path__ + "img/logo.df043ce1.png";